// import { useState, useEffect, useRef } from 'react';
import iphonecard from '../assets/iphonecard.jpg';
import hublotcard from '../assets/hublotcard.jpg';
import nikecardpic from '../assets/nikecardpic.jpg';
import ringcardpic from '../assets/ringcardpic.jpg';
import clothescardpic from '../assets/clothescardpic.jpg';
// import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const cardImages = [hublotcard, nikecardpic, iphonecard, ringcardpic, clothescardpic];

const Scrollcard = () => {
  // const [currentImage, setCurrentImage] = useState(cardImages[0]);
  // const intervalIdRef = useRef(null);

  // useEffect(() => {
  //   intervalIdRef.current = setInterval(() => {
  //     let temp = cardImages.shift();
  //     cardImages.push(temp);
  //     setCurrentImage(cardImages[0]);
  //   }, 4000);

  //   return () => {
  //     clearInterval(intervalIdRef.current);
  //   };
  // }, []);

  // const next = () => {
  //   let temp = cardImages.shift();
  //   cardImages.push(temp);
  //   setCurrentImage(cardImages[0]);
  // };

  // const prev = () => {
  //   let k = cardImages.indexOf(currentImage);
  //   if (k === 0) {
  //     k = cardImages.length;
  //   } else {
  //     k--;
  //   }
  //   setCurrentImage(cardImages[k - 1]);
  // };

  // const [products, setProducts] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch('https://dummyjson.com/products');
  //       const data = await response.json();
  //       setProducts(data);
  //       // console.log(data)
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {/* <div className='sm:hidden w-full flex justify-center items-center pt-4 animate-fade-right'>
        <img id='scroll-card-image' src={currentImage} alt='ccsrollcardpic' className='w-3/4 sm:w-full shadow rounded '/>
      </div>
      <div className=" w-full sm:w-full md:hidden lg:hidden xl:hidden 2xl:hidden h-60 sm:h-44 bg-cover bg-center"
          style={{ backgroundImage: `url(${currentImage})` }}
         ></div>
      <div className='flex flex-row justify-center align-middle items-center gap-12 mt-2'>
        <button id='btnprev' onClick={prev} ><AiOutlineArrowLeft className='text-blue-600 ' /></button>
        <button id='btnext' onClick={next}><AiOutlineArrowRight className='text-blue-600 '/></button>
      </div> */}


      {/* <div id="custom-controls-gallery" className="relative w-full sm:hidden md:flex xl:flex lg:flex 2xl:flex flex-col animate-fade" data-carousel="slide">

        <div className="relative overflow-hidden rounded-lg h-80 sm:h-48">



          <div className="hidden duration-700 ease-in-out" data-carousel-item>
            <img src={iphonecard} className="absolute rounded shadow w-3/4 sm:w-full max-w-3/4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
          </div>

          <div className="hidden duration-700 ease-in-out" data-carousel-item="active">
            <img src={hublotcard} className="absolute rounded shadow w-3/4 sm:w-full max-w-3/4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
          </div>

          <div className="hidden duration-700 ease-in-out" data-carousel-item>
            <img src={nikecardpic} className="absolute rounded shadow w-3/4 sm:w-full max-w-3/4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
          </div>

          <div className="hidden duration-700 ease-in-out" data-carousel-item>
            <img src={ringcardpic} className="absolute rounded shadow w-3/4 sm:w-full max-w-3/4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
          </div>

          <div className="hidden duration-700 ease-in-out" data-carousel-item>
            <img src={clothescardpic} className="absolute rounded shadow w-3/4 sm:w-full max-w-3/4 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="" />
          </div>
        </div>
        <div className="flex justify-center items-center pt-2">
          <button type="button" className="flex justify-center items-center mr-4 h-full cursor-pointer group focus:outline-none" data-carousel-prev>
            <span className="text-gray-400 hover:text-gray-900 ">
              <AiOutlineArrowLeft/>
              <span className="sr-only">Previous</span>
            </span>
          </button>
          <button type="button" className="flex justify-center items-center h-full cursor-pointer group focus:outline-none" data-carousel-next>
            <span className="text-gray-400 hover:text-gray-900 ">
              <AiOutlineArrowRight/>
              <span className="sr-only">Next</span>
            </span>
          </button>
        </div>
      </div> */}

<div className="m-0">
      <Slider {...settings}>
        {cardImages.map((image, index) => (
          <div key={index} className='w-full  rounded'>
            <img
              className="w-full sm:h-48 object-cover rounded"
              src={image}
              alt={`carousel-${index}`}
            />
          </div>
        ))}
      </Slider>
    </div>

{/* for mobile  */}
      {/* <div id="custom-controls-gallery" className="relative w-full sm:flex md:hidden lg:hidden xl:hidden 2xl:hidden flex-col" data-carousel="slide">

        <div className="relative overflow-hidden h-80 sm:h-44">

          <div className='relative overflow-hidden h-80 sm:h-48'>
            <div className=" w-full sm:w-full  h-60 sm:h-44 bg-cover bg-center hidden duration-700 ease-in-out"
              style={{ backgroundImage: `url(${iphonecard})` }} data-carousel-item
            ></div>
            <div className=" w-full sm:w-full md:hidden lg:hidden xl:hidden 2xl:hidden h-60 sm:h-44 bg-cover bg-center hidden duration-700 ease-in-out"
              style={{ backgroundImage: `url(${hublotcard})` }} data-carousel-item
            ></div>
            <div className=" w-full sm:w-full md:hidden lg:hidden xl:hidden 2xl:hidden h-60 sm:h-44 bg-cover bg-center hidden duration-700 ease-in-out"
              style={{ backgroundImage: `url(${clothescardpic})` }} data-carousel-item
            ></div>
          </div>
        </div>
        <div className="flex justify-center items-center pt-2">
          <button type="button" className="flex justify-center items-center mr-4 h-full cursor-pointer group focus:outline-none" data-carousel-prev>
            <span className="text-gray-400 hover:text-gray-900 ">
              <AiOutlineArrowLeft/>
              <span className="sr-only">Previous</span>
            </span>
          </button>
          <button type="button" className="flex justify-center items-center h-full cursor-pointer group focus:outline-none" data-carousel-next>
            <span className="text-gray-400 hover:text-gray-900 ">
              <AiOutlineArrowRight/>
              <span className="sr-only">Next</span>
            </span>
          </button>
        </div>
      </div> */}
    </>
  );
};

export default Scrollcard;